<script setup>
import { computed } from 'vue';

const props = defineProps({
	variant: {
		type: String,
		default: 'dark',
		validator: value => ['dark', 'light'].includes(value),
	},
	size: {
		type: String,
		default: 'sidebar',
		validator: value => ['sidebar', 'compact', 'auth'].includes(value),
	},
});

const styleVars = computed(() => {
	if (props.size === 'auth') {
		return {
			'--brand-logo-height': '27px',
			'--brand-logo-font-size': '27px',
		};
	}

	if (props.size === 'compact') {
		return {
			'--brand-logo-height': '20px',
			'--brand-logo-font-size': '14px',
		};
	}

	return {
		'--brand-logo-height': '22px',
		'--brand-logo-font-size': '22px',
	};
});

const logoText = computed(() =>
	props.size === 'compact' ? 'Y365' : 'YouEvent365'
);
</script>

<template>
	<span
		class="brand-wordmark"
		:class="[`brand-wordmark--${variant}`, `brand-wordmark--${size}`]"
		:style="styleVars"
		role="img"
		aria-label="YouEvent365"
	>
		<span class="brand-wordmark__text" aria-hidden="true">{{ logoText }}</span>
	</span>
</template>

<style scoped>
@font-face {
	font-family: 'YouEvent365 Logo';
	font-style: normal;
	font-weight: 700;
	font-display: swap;
	src: url('https://fonts.gstatic.com/s/oleoscript/v14/raxkHieDvtMOe0iICsUccCDmnlrf0Ts.woff2')
		format('woff2');
	unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC,
		U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F,
		U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF,
		U+FFFD;
}

.brand-wordmark {
	display: inline-flex;
	align-items: center;
	height: var(--brand-logo-height);
	line-height: 1;
}

.brand-wordmark--dark {
	--brand-logo-gradient: linear-gradient(
		90deg,
		#2563eb 0%,
		#0891b2 52%,
		#34d399 100%
	);
}

.brand-wordmark--light {
	--brand-logo-gradient: linear-gradient(
		90deg,
		#93c5fd 0%,
		#67e8f9 52%,
		#6ee7b7 100%
	);
}

.brand-wordmark__text {
	display: inline-block;
	color: #2563eb;
	font-family: 'YouEvent365 Logo', 'Oleo Script', 'Script MT Bold', cursive;
	font-size: var(--brand-logo-font-size);
	font-style: normal;
	font-weight: 700;
	font-synthesis: none;
	line-height: var(--brand-logo-height);
	white-space: nowrap;
	background: var(--brand-logo-gradient);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
}
</style>
